import React, { useEffect, useState } from 'react';
import {BsFillBasket2Fill} from "react-icons/bs";
import {HiOutlineLocationMarker} from "react-icons/hi";
import {BiReceipt, BiChevronRight, BiChevronLeft, BiTrash, BiX} from "react-icons/bi";
import { AiOutlinePlus } from 'react-icons/ai';
import CartService from '../../Utils/API/cart';
import { toast } from 'react-toastify';
import isMobile from '../../Components/Miscellaneous/Utils/isMobile';
import AddressService from '../../Utils/API/address';
import {IoIosCheckmarkCircle} from 'react-icons/io';
import { Loader } from '../Login/style';
import OrderService from '../../Utils/API/orders';
import ReactGA from 'react-ga4';
import { FiPackage, FiMapPin, FiCreditCard, FiTruck, FiCheck } from 'react-icons/fi';

export default function Checkout() {
    const [products, setProducts] = useState([]);
    const [step, setStep] = useState(0);
    const [cartID, setCartID] = useState(null);
    const [address, setAddress] = useState([])
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [dropshipping, setDropshipping] = useState([]);
    const [loading, setLoading] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState(0);
    const [loadingOrder, setLoadingOrder] = useState(false);

    useEffect(() => {
        setLoading(true);
        const getProducts = async () => {
            const products = await CartService.getCart();
            setProducts(products.items);
            setCartID(products._id);

            const stockValidation = await CartService.validateAndShowCartErrors();
            if (stockValidation.hasStockIssues) {
                toast.warning('Algunos productos en tu carrito tienen problemas de stock');
            }

            setLoading(false);
            setStep(1);
        }

        const getAddress = async () => {
            const address = await AddressService.getAddresses();
            if(address.length > 0){
                setSelectedAddress(address[0]._id);
            }
            setAddress(address);
        }
        const getDropshipping = async () => {
            const dropshipping = await AddressService.getDropshippingAddresses();
            setDropshipping(dropshipping);
        }
        getDropshipping();
        getProducts();
        getAddress();
    }, []);

    function addQuantity(id) {
        const newProducts = products.map(product => {
            if(product._id === id){
                product.quantity = parseInt(product.quantity) + 1*product.quantityStep;
                CartService.addProductQuantity(product.productID, product.quantity);
            }
            return product;
        });
        setProducts(newProducts);
    }

    function removeQuantity(id) {
        const newProducts = products.map(product => {
            if(product._id === id){
                product.quantity = parseInt(product.quantity) - 1*product.quantityStep;
                if(product.quantity < 0){
                    product.quantity = 0;
                }
            }
            return product;
        });
        setProducts(newProducts);
        CartService.addProductQuantity(newProducts.find(product => product._id === id).productID, newProducts.find(product => product._id === id).quantity+"");
    }

    function changeQuantity(id, quantity) {
        let timer;
        const newProducts = products.map(product => {
            if(product._id === id){
                const requestedQty = parseInt(quantity) || 0;
                const availableStock = product.availableStock || product.stock || 0;

                // Si la cantidad solicitada es menor o igual al stock disponible, permitir cualquier valor
                if(requestedQty <= availableStock) {
                    product.quantity = requestedQty;

                    // Solo ajustar al quantityStep si hay suficiente stock
                    if(requestedQty % product.quantityStep !== 0 && requestedQty < availableStock) {
                        // Programar ajuste después de un breve delay
                        clearTimeout(timer);
                        timer = setTimeout(() => {
                            checkMultiple(id);
                        }, 800);
                    } else {
                        CartService.addProductQuantity(product.productID, product.quantity);
                    }
                } else {
                    // Si excede el stock, limitar al stock disponible
                    product.quantity = availableStock;
                    toast.warning(`Stock limitado a ${availableStock} unidades`);
                }

                CartService.addProductQuantity(product.productID, product.quantity);
            }
            return product;
        });
        setProducts(newProducts);
    }

    function checkMultiple(id) {
        const newProducts = products.map(product => {
            if(product._id === id){
                const availableStock = product.availableStock || product.stock || 0;

                // Solo ajustar al múltiplo si no estamos en situación de stock bajo
                if(product.quantity % product.quantityStep !== 0 && product.quantity < availableStock){
                    // Redondear hacia arriba al múltiplo más cercano
                    const adjustedQty = Math.ceil(product.quantity / product.quantityStep) * product.quantityStep;

                    // Si el ajuste excede el stock, usar el stock disponible
                    product.quantity = adjustedQty <= availableStock ? adjustedQty : availableStock;

                    CartService.addProductQuantity(product.productID, product.quantity);
                    toast.info(`Cantidad ajustada a ${product.quantity} (múltiplo de ${product.quantityStep})`);
                }
            }
            return product;
        });
        setProducts(newProducts);
    }

    const calculateTotal = () => {
        return products.reduce((accumulator, currentValue) => {
            const productPrice = currentValue.discounts && currentValue.discounts.length > 0
                ? currentValue.discounts.find(discount => currentValue.quantity >= discount.minQuantity)
                    ? currentValue.discounts.find(discount => currentValue.quantity >= discount.minQuantity).discountedPrice
                    : currentValue.price
                : currentValue.price;
            return accumulator + (productPrice * currentValue.quantity);
        }, 0);
    };

    const getShippingCost = () => {
        return calculateTotal() >= 100 ? 0 : 6;
    };

    const createOrder = () => {
        setLoadingOrder(true);
        OrderService.createOrder({
            addressID: selectedAddress,
            dropshipping: dropshipping.filter(item => item._id === selectedAddress).length > 0 ? true : false,
            paymentMethod: paymentMethod,
            cartID: cartID,
        }).then(response => {
            if(response.Status === "Created"){
                toast.success('Pedido realizado');
                setLoadingOrder(false);
                window.location.href='/me/orders';
            }else{
                toast.error(response.message);
                setLoadingOrder(false);
            }
        }).catch(error => {
            console.log(error);
            setLoadingOrder(false);
        })
    };

    const canProceedToNextStep = () => {
        if (step === 1) return products.length > 0;
        if (step === 2) return selectedAddress !== null;
        if (step === 3) return true;
        return false;
    };

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                backgroundColor: '#f9fafb'
            }}>
                <Loader />
            </div>
        );
    }

    return (
        <div style={{
            minHeight: '100vh',
            backgroundColor: '#f9fafb',
            paddingBottom: '100px'
        }}>
            {/* Header */}
            <div style={{
                backgroundColor: '#fff',
                borderBottom: '1px solid #e5e7eb',
                padding: '20px 24px',
                position: 'sticky',
                top: 0,
                zIndex: 0
            }}>
                <div style={{
                    maxWidth: '1200px',
                    margin: '0 auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <h1 style={{
                        fontSize: '24px',
                        fontWeight: '700',
                        color: '#111827',
                        margin: 0,
                        fontFamily: 'Inter, sans-serif'
                    }}>
                        Finalizar compra
                    </h1>

                    {/* Steps indicator */}
                    <div style={{
                        display: 'flex',
                        gap: '32px',
                        alignItems: 'center'
                    }}>
                        {[
                            { num: 1, icon: FiPackage, label: 'Carrito' },
                            { num: 2, icon: FiMapPin, label: 'Dirección' },
                            { num: 3, icon: FiCreditCard, label: 'Pago' }
                        ].map((s, idx) => (
                            <div key={s.num} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <div style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '50%',
                                    backgroundColor: step >= s.num ? '#028322' : '#e5e7eb',
                                    color: step >= s.num ? '#fff' : '#9ca3af',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    transition: 'all 0.3s ease'
                                }}>
                                    {step > s.num ? <FiCheck size={20} /> : <s.icon size={20} />}
                                </div>
                                {!isMobile() && (
                                    <span style={{
                                        fontSize: '14px',
                                        fontWeight: step >= s.num ? '600' : '400',
                                        color: step >= s.num ? '#028322' : '#9ca3af',
                                        fontFamily: 'Inter, sans-serif'
                                    }}>
                                        {s.label}
                                    </span>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div style={{
                maxWidth: '1200px',
                margin: '0 auto',
                padding: '32px 24px',
                display: 'grid',
                gridTemplateColumns: '1fr 400px',
                gap: '32px'
            }}>
                {/* Left Column - Main Content */}
                <div>
                    {/* Step 1: Cart */}
                    {step === 1 && (
                        <div>
                            <h2 style={{
                                fontSize: '20px',
                                fontWeight: '600',
                                color: '#111827',
                                marginBottom: '20px',
                                fontFamily: 'Inter, sans-serif'
                            }}>
                                Productos en tu carrito ({products.length})
                            </h2>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                {products.map(product => (
                                    <div key={product._id} style={{
                                        backgroundColor: '#fff',
                                        border: '1px solid #e5e7eb',
                                        borderRadius: '12px',
                                        padding: '20px',
                                        display: 'flex',
                                        gap: '20px',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)'}
                                    onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
                                    >
                                        {/* Image */}
                                        <img
                                            src={product?.images[0]}
                                            alt={product?.name}
                                            style={{
                                                width: '120px',
                                                height: '120px',
                                                objectFit: 'cover',
                                                borderRadius: '8px',
                                                border: '1px solid #e5e7eb',
                                                cursor: 'pointer',
                                                flexShrink: 0
                                            }}
                                            onClick={() => window.location.href='/details/'+product?.productURL}
                                        />

                                        {/* Info */}
                                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                            <div>
                                                <h3 style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600',
                                                    color: '#111827',
                                                    margin: '0 0 8px 0',
                                                    fontFamily: 'Inter, sans-serif',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => window.location.href='/details/'+product?.productURL}
                                                >
                                                    {product?.name}
                                                </h3>
                                                <p style={{
                                                    fontSize: '20px',
                                                    fontWeight: '700',
                                                    color: '#028322',
                                                    margin: 0,
                                                    fontFamily: 'Inter, sans-serif'
                                                }}>
                                                    {product?.price}€
                                                </p>

                                                {/* Stock warnings */}
                                                {product?.stockInfo?.warnings && product.stockInfo.warnings.length > 0 && (
                                                    <div style={{ marginTop: '8px' }}>
                                                        {product.stockInfo.warnings.map((warning, idx) => (
                                                            <div key={idx} style={{
                                                                fontSize: '13px',
                                                                fontWeight: '500',
                                                                color: warning.includes('Sin stock') ? '#dc2626' : '#f59e0b',
                                                                backgroundColor: warning.includes('Sin stock') ? '#fee2e2' : '#fef3c7',
                                                                padding: '6px 10px',
                                                                borderRadius: '6px',
                                                                marginBottom: idx < product.stockInfo.warnings.length - 1 ? '4px' : '0',
                                                                fontFamily: 'Inter, sans-serif',
                                                                border: `1px solid ${warning.includes('Sin stock') ? '#fca5a5' : '#fcd34d'}`
                                                            }}>
                                                                {warning}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {/* No stock warning */}
                                                {!product?.hasEnoughStock && product?.stockInfo && (
                                                    <div style={{
                                                        fontSize: '13px',
                                                        fontWeight: '500',
                                                        color: '#dc2626',
                                                        backgroundColor: '#fee2e2',
                                                        padding: '6px 10px',
                                                        borderRadius: '6px',
                                                        marginTop: '8px',
                                                        fontFamily: 'Inter, sans-serif',
                                                        border: '1px solid #fca5a5'
                                                    }}>
                                                        Sin stock suficiente (disponible: {product.stockInfo.available})
                                                    </div>
                                                )}
                                            </div>

                                            {/* Quantity controls */}
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    border: '1px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    overflow: 'hidden'
                                                }}>
                                                    <button
                                                        onClick={() => removeQuantity(product?._id)}
                                                        style={{
                                                            width: '36px',
                                                            height: '36px',
                                                            border: 'none',
                                                            backgroundColor: '#f9fafb',
                                                            cursor: 'pointer',
                                                            fontSize: '18px',
                                                            fontWeight: '600',
                                                            color: '#028322',
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#e5e7eb'}
                                                        onMouseLeave={(e) => e.target.style.backgroundColor = '#f9fafb'}
                                                    >
                                                        -
                                                    </button>
                                                    <input
                                                        type="number"
                                                        value={product?.quantity}
                                                        onChange={(e) => changeQuantity(product?._id, e.target.value)}
                                                        style={{
                                                            width: '60px',
                                                            height: '36px',
                                                            border: 'none',
                                                            textAlign: 'center',
                                                            fontSize: '14px',
                                                            fontWeight: '600',
                                                            fontFamily: 'Inter, sans-serif',
                                                            outline: 'none'
                                                        }}
                                                    />
                                                    <button
                                                        onClick={() => addQuantity(product?._id)}
                                                        style={{
                                                            width: '36px',
                                                            height: '36px',
                                                            border: 'none',
                                                            backgroundColor: '#f9fafb',
                                                            cursor: 'pointer',
                                                            fontSize: '18px',
                                                            fontWeight: '600',
                                                            color: '#028322',
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#e5e7eb'}
                                                        onMouseLeave={(e) => e.target.style.backgroundColor = '#f9fafb'}
                                                    >
                                                        +
                                                    </button>
                                                </div>

                                                <button
                                                    onClick={() => {
                                                        const productIdToDelete = typeof product?.productID === 'object' ? product?.productID?._id || product?._id : product?.productID;
                                                        CartService.deleteProductFromCart(productIdToDelete).then(res => {
                                                            setProducts(products.filter(p => p._id !== product._id));
                                                        })
                                                    }}
                                                    style={{
                                                        padding: '8px',
                                                        backgroundColor: '#fff',
                                                        border: '1px solid #e5e7eb',
                                                        borderRadius: '8px',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.2s ease',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.borderColor = '#dc2626';
                                                        e.target.style.backgroundColor = '#fee2e2';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.borderColor = '#e5e7eb';
                                                        e.target.style.backgroundColor = '#fff';
                                                    }}
                                                >
                                                    <BiTrash size={20} color="#dc2626" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Step 2: Address */}
                    {step === 2 && (
                        <div>
                            <h2 style={{
                                fontSize: '20px',
                                fontWeight: '600',
                                color: '#111827',
                                marginBottom: '20px',
                                fontFamily: 'Inter, sans-serif'
                            }}>
                                Dirección de envío
                            </h2>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '32px' }}>
                                {/* Add address button */}
                                <div
                                    onClick={() => window.location.href='/me/address'}
                                    style={{
                                        backgroundColor: '#fff',
                                        border: '2px dashed #e5e7eb',
                                        borderRadius: '12px',
                                        padding: '24px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '12px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.borderColor = '#028322';
                                        e.currentTarget.style.backgroundColor = '#f0fdf4';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.borderColor = '#e5e7eb';
                                        e.currentTarget.style.backgroundColor = '#fff';
                                    }}
                                >
                                    <AiOutlinePlus size={20} color="#028322" />
                                    <span style={{
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: '#028322',
                                        fontFamily: 'Inter, sans-serif'
                                    }}>
                                        Añadir nueva dirección
                                    </span>
                                </div>

                                {address.map((addr) => (
                                    <div
                                        key={addr._id}
                                        onClick={() => setSelectedAddress(addr._id)}
                                        style={{
                                            backgroundColor: '#fff',
                                            border: `2px solid ${selectedAddress === addr._id ? '#028322' : '#e5e7eb'}`,
                                            borderRadius: '12px',
                                            padding: '20px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: '12px'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)'}
                                        onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
                                    >
                                        <IoIosCheckmarkCircle
                                            size={24}
                                            color={selectedAddress === addr._id ? '#028322' : '#d1d5db'}
                                        />
                                        <div style={{ flex: 1 }}>
                                            <p style={{
                                                fontSize: '15px',
                                                fontWeight: '600',
                                                color: '#111827',
                                                margin: '0 0 8px 0',
                                                fontFamily: 'Inter, sans-serif'
                                            }}>
                                                {addr.Address}
                                            </p>
                                            <p style={{
                                                fontSize: '14px',
                                                color: '#6b7280',
                                                margin: 0,
                                                fontFamily: 'Inter, sans-serif'
                                            }}>
                                                {addr.City}, {addr.ZIP}, {addr.Province}, {addr.Country}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Dropshipping section */}
                            {dropshipping.length > 0 && (
                                <>
                                    <h3 style={{
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        color: '#111827',
                                        marginBottom: '16px',
                                        fontFamily: 'Inter, sans-serif'
                                    }}>
                                        Dropshipping
                                        <span style={{ fontSize: '14px', fontWeight: '400', color: '#6b7280', marginLeft: '8px' }}>
                                            (Envío a terceros)
                                        </span>
                                    </h3>

                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                        <div
                                            onClick={() => window.location.href='/me/dropshipping'}
                                            style={{
                                                backgroundColor: '#fff',
                                                border: '2px dashed #e5e7eb',
                                                borderRadius: '12px',
                                                padding: '24px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '12px',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.borderColor = '#028322';
                                                e.currentTarget.style.backgroundColor = '#f0fdf4';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.borderColor = '#e5e7eb';
                                                e.currentTarget.style.backgroundColor = '#fff';
                                            }}
                                        >
                                            <AiOutlinePlus size={20} color="#028322" />
                                            <span style={{
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                color: '#028322',
                                                fontFamily: 'Inter, sans-serif'
                                            }}>
                                                Añadir cliente dropshipping
                                            </span>
                                        </div>

                                        {dropshipping.map((item) => (
                                            <div
                                                key={item._id}
                                                onClick={() => setSelectedAddress(item._id)}
                                                style={{
                                                    backgroundColor: '#fff',
                                                    border: `2px solid ${selectedAddress === item._id ? '#028322' : '#e5e7eb'}`,
                                                    borderRadius: '12px',
                                                    padding: '20px',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease',
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                    gap: '12px'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)'}
                                                onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
                                            >
                                                <IoIosCheckmarkCircle
                                                    size={24}
                                                    color={selectedAddress === item._id ? '#028322' : '#d1d5db'}
                                                />
                                                <div>
                                                    <p style={{
                                                        fontSize: '15px',
                                                        fontWeight: '600',
                                                        color: '#111827',
                                                        margin: '0 0 4px 0',
                                                        fontFamily: 'Inter, sans-serif'
                                                    }}>
                                                        {item.Name} {item.Surname}
                                                    </p>
                                                    <p style={{
                                                        fontSize: '14px',
                                                        color: '#6b7280',
                                                        margin: '0 0 4px 0',
                                                        fontFamily: 'Inter, sans-serif'
                                                    }}>
                                                        {item.Address}, {item.City}, {item.ZIP}
                                                    </p>
                                                    <p style={{
                                                        fontSize: '13px',
                                                        color: '#9ca3af',
                                                        margin: 0,
                                                        fontFamily: 'Inter, sans-serif'
                                                    }}>
                                                        {item.Email}
                                                    </p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    )}

                    {/* Step 3: Payment */}
                    {step === 3 && (
                        <div>
                            <h2 style={{
                                fontSize: '20px',
                                fontWeight: '600',
                                color: '#111827',
                                marginBottom: '20px',
                                fontFamily: 'Inter, sans-serif'
                            }}>
                                Método de pago
                            </h2>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '32px' }}>
                                <div
                                    onClick={() => setPaymentMethod(0)}
                                    style={{
                                        backgroundColor: '#fff',
                                        border: `2px solid ${paymentMethod === 0 ? '#028322' : '#e5e7eb'}`,
                                        borderRadius: '12px',
                                        padding: '20px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)'}
                                    onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
                                >
                                    <IoIosCheckmarkCircle
                                        size={24}
                                        color={paymentMethod === 0 ? '#028322' : '#d1d5db'}
                                    />
                                    <span style={{
                                        fontSize: '15px',
                                        fontWeight: '600',
                                        color: '#111827',
                                        fontFamily: 'Inter, sans-serif'
                                    }}>
                                        Transferencia bancaria
                                    </span>
                                </div>

                                <div
                                    onClick={() => setPaymentMethod(1)}
                                    style={{
                                        backgroundColor: '#fff',
                                        border: `2px solid ${paymentMethod === 1 ? '#028322' : '#e5e7eb'}`,
                                        borderRadius: '12px',
                                        padding: '20px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)'}
                                    onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
                                >
                                    <IoIosCheckmarkCircle
                                        size={24}
                                        color={paymentMethod === 1 ? '#028322' : '#d1d5db'}
                                    />
                                    <span style={{
                                        fontSize: '15px',
                                        fontWeight: '600',
                                        color: '#111827',
                                        fontFamily: 'Inter, sans-serif'
                                    }}>
                                        Pago según convenio
                                    </span>
                                </div>
                            </div>

                            {/* Shipping info */}
                            <h3 style={{
                                fontSize: '18px',
                                fontWeight: '600',
                                color: '#111827',
                                marginBottom: '16px',
                                fontFamily: 'Inter, sans-serif'
                            }}>
                                Información de envío
                            </h3>

                            <div style={{
                                backgroundColor: '#f0fdf4',
                                border: '1px solid #bbf7d0',
                                borderRadius: '12px',
                                padding: '16px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                            }}>
                                <FiTruck size={24} color="#028322" />
                                <div>
                                    <p style={{
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: '#028322',
                                        margin: '0 0 4px 0',
                                        fontFamily: 'Inter, sans-serif'
                                    }}>
                                        Envío mediante Distribuciones RB
                                    </p>
                                    <p style={{
                                        fontSize: '13px',
                                        color: '#16a34a',
                                        margin: 0,
                                        fontFamily: 'Inter, sans-serif'
                                    }}>
                                        {getShippingCost() === 0 ? '¡Envío gratuito en pedidos superiores a 100€!' : 'Gastos de envío: 6€'}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Right Column - Summary */}
                <div style={{ position: 'sticky', top: '100px', height: 'fit-content' }}>
                    <div style={{
                        backgroundColor: '#fff',
                        border: '1px solid #e5e7eb',
                        borderRadius: '12px',
                        padding: '24px'
                    }}>
                        <h3 style={{
                            fontSize: '18px',
                            fontWeight: '600',
                            color: '#111827',
                            marginBottom: '20px',
                            fontFamily: 'Inter, sans-serif'
                        }}>
                            Resumen del pedido
                        </h3>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, sans-serif' }}>
                                    Subtotal ({products.length} productos)
                                </span>
                                <span style={{ fontSize: '14px', fontWeight: '600', color: '#111827', fontFamily: 'Inter, sans-serif' }}>
                                    {calculateTotal().toFixed(2)}€
                                </span>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, sans-serif' }}>
                                    Envío
                                </span>
                                <span style={{ fontSize: '14px', fontWeight: '600', color: getShippingCost() === 0 ? '#16a34a' : '#111827', fontFamily: 'Inter, sans-serif' }}>
                                    {getShippingCost() === 0 ? 'GRATIS' : `${getShippingCost()}€`}
                                </span>
                            </div>

                            <div style={{ height: '1px', backgroundColor: '#e5e7eb', margin: '8px 0' }} />

                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ fontSize: '16px', fontWeight: '600', color: '#111827', fontFamily: 'Inter, sans-serif' }}>
                                    Total
                                </span>
                                <span style={{ fontSize: '20px', fontWeight: '700', color: '#028322', fontFamily: 'Inter, sans-serif' }}>
                                    {(calculateTotal() + getShippingCost()).toFixed(2)}€
                                </span>
                            </div>
                        </div>

                        {/* Action buttons */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {step < 3 ? (
                                <button
                                    onClick={() => canProceedToNextStep() && setStep(step + 1)}
                                    disabled={!canProceedToNextStep()}
                                    style={{
                                        width: '100%',
                                        padding: '14px',
                                        backgroundColor: canProceedToNextStep() ? '#028322' : '#e5e7eb',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        fontSize: '15px',
                                        fontWeight: '600',
                                        fontFamily: 'Inter, sans-serif',
                                        cursor: canProceedToNextStep() ? 'pointer' : 'not-allowed',
                                        transition: 'all 0.2s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (canProceedToNextStep()) {
                                            e.target.style.backgroundColor = '#026d1b';
                                            e.target.style.transform = 'translateY(-2px)';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (canProceedToNextStep()) {
                                            e.target.style.backgroundColor = '#028322';
                                            e.target.style.transform = 'translateY(0)';
                                        }
                                    }}
                                >
                                    Continuar
                                    <BiChevronRight size={20} />
                                </button>
                            ) : (
                                <button
                                    onClick={createOrder}
                                    disabled={loadingOrder}
                                    style={{
                                        width: '100%',
                                        padding: '14px',
                                        backgroundColor: loadingOrder ? '#e5e7eb' : '#028322',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        fontSize: '15px',
                                        fontWeight: '600',
                                        fontFamily: 'Inter, sans-serif',
                                        cursor: loadingOrder ? 'not-allowed' : 'pointer',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!loadingOrder) {
                                            e.target.style.backgroundColor = '#026d1b';
                                            e.target.style.transform = 'translateY(-2px)';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!loadingOrder) {
                                            e.target.style.backgroundColor = '#028322';
                                            e.target.style.transform = 'translateY(0)';
                                        }
                                    }}
                                >
                                    {loadingOrder ? 'Procesando...' : 'Finalizar pedido'}
                                </button>
                            )}

                            {step > 1 && (
                                <button
                                    onClick={() => setStep(step - 1)}
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        backgroundColor: '#fff',
                                        color: '#6b7280',
                                        border: '1px solid #e5e7eb',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        fontFamily: 'Inter, sans-serif',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.borderColor = '#028322';
                                        e.target.style.color = '#028322';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.borderColor = '#e5e7eb';
                                        e.target.style.color = '#6b7280';
                                    }}
                                >
                                    <BiChevronLeft size={20} />
                                    Volver
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
